const KEY_PREFIX = 'fpsb.portal.verification.draft.';

// Backstop for sessions that ended without a logout.
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export type VerificationDraftData = {
    // eslint-disable-next-line
    formData:any,
    dinOtherBilling:boolean,
    assignments:{ [examType:string]:string|null },
    dismissedInline:{ [examType:string]:boolean },
    // eslint-disable-next-line
    inlineByExamType:any,
};

export type VerificationDraft = {
    savedAt:number,
    contactId:string|number|null,
    data:VerificationDraftData,
};

const storageKey = (draftKey:string) => KEY_PREFIX + draftKey;

export const readDraft = (draftKey:string):VerificationDraft|null => {
    try {
        const raw = window.localStorage.getItem(storageKey(draftKey));
        if (!raw) {
            return null;
        }
        const stored = JSON.parse(raw);
        if (!stored || !stored.data || (Date.now() - Number(stored.savedAt)) > MAX_AGE_MS) {
            clearDraft(draftKey);
            return null;
        }
        return {
            savedAt: Number(stored.savedAt),
            contactId: stored.contactId ?? null,
            data: stored.data,
        };
    } catch (e) {
        return null;
    }
};

export const writeDraft = (draftKey:string, data:VerificationDraftData, contactId:string|number|null = null) => {
    try {
        window.localStorage.setItem(storageKey(draftKey), JSON.stringify({
            savedAt: Date.now(),
            contactId,
            data,
        }));
    } catch (e) {
        // Storage full or unavailable – the form works without a draft.
    }
};

// No key clears every draft.
export const clearDraft = (draftKey?:string) => {
    try {
        if (draftKey) {
            window.localStorage.removeItem(storageKey(draftKey));
            return;
        }
        Object.keys(window.localStorage)
            .filter(key => key.indexOf(KEY_PREFIX) === 0)
            .forEach(key => window.localStorage.removeItem(key));
    } catch (e) {
        // nothing to clean up
    }
};
